import LOGO from "../../PFC_Images/PFC46.png";
import SPRAY from "../../PFC_Images/spray.JPG"

const GolfOne = () => {
    return (
        <div className="w-full h-full relative bg-black text-black">
            
            <img
                src={SPRAY}
                alt="background"
                className={`absolute duration-1000 opacity-70 inset-0 w-full h-full object-cover`}
            />
            
            <img
                src={LOGO}
                alt="background"
                className={`z-50 absolute top-2 left-2 size-24 inset-0 object-cover`}
            />
            
            <div className={`z-50 w-full h-full flex items-center justify-center`}>
                
                <div className={`z-50 w-2/3 flex flex-col backdrop-blur-sm p-4 rounded-2xl drop-shadow-2xl`}>
                    
                    <span className={`text-2xl flex flex-col font-bold text-white`}>
                        <span className={``}>Built for Those</span>
                        <span className={``}>Who Demand Better Turf</span>
                    </span>
                    <span className={`mt-3 text-sm text-gray-200 italic`}>At Plant Food Company, we don’t just supply fertilizer—we deliver performance. Our liquid solutions are crafted for professionals who expect precision, efficiency, and visible results with every application.</span>
                </div>
            
            </div>
            
        
        </div>
    )
}

export default GolfOne;
